require('./transfersScheduledView.scss');
const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ actions
const scheduledTransfersActions = require('actions/scheduledTransfers');
// @ components
const ScheduledTransfers = require('components/transfers/scheduled/scheduledTransfers/scheduledTransfers');
const TransfersMoreOptionsButton = require('components/transfers/transfersMoreOptionsButton/transfersMoreOptionsButton')
const TransfersOptionsButton = require('components/transfers/transfersOptionsButton/transfersOptionsButton');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
// @ utilities
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')
// @ constants
const { GRAPHIC_TUTOR_TYPE_3 } = require('constants/index');
const { WEB_INACTIVE_ACCOUNT_ENABLED } = require('constants/flagBasedFeatures');

class TransfersScheduledView extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentWillUnmount() {
        const immScheduledTransfersFilters = this.props.immScheduledTransfers.get('filters');

        if (immScheduledTransfersFilters.getIn(['amount', 'isActive']) ||
            immScheduledTransfersFilters.getIn(['currency', 'isActive'])) {
            this.props.clearFilters();
        }
    }

    render() {
        const {
            match: { params: { accountId } },
            immAccounts,
            immFlagBasedFeatures,
            immScheduledTransfers,
            immScreen,
            requestScheduledTransfers,
            resetFilter,
            setFilters,
            clearFilters,
            requestScheduledTransfersNextPage
        } = this.props;
        const immAccount = immAccounts.get('byId').get(accountId);
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-transfers'),
                url: '/myprofile/transfers'
            },
            {
                text: formatText('transfersLanding-scheduledTranfers')
            }
        ];
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_3}
                title={formatText('tutorials-transfersScheduledTitle')}
            />
        );
        let moreOptionsButton;
        let optionsButton;
        let content;

        if (immAccount) {
            moreOptionsButton = (<TransfersMoreOptionsButton immAccount={immAccount} />);
            optionsButton = (<TransfersOptionsButton immAccount={immAccount} />);
            content = (
                <ScheduledTransfers
                    immAccount={immAccount}
                    immAccounts={immAccounts}
                    immScheduledTransfers={immScheduledTransfers}
                    immScreen={immScreen}
                    isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                    requestScheduledTransfers={requestScheduledTransfers}
                    setFilters={setFilters}
                    resetFilter={resetFilter}
                    clearFilters={clearFilters}
                    requestScheduledTransfersNextPage={requestScheduledTransfersNextPage}
                />
            );
        } else {
            content = (<LoadingSection />);
        }

        const transfersScheduledClassName = contactCenterClassName('transfers-scheduled-view')
        const transfersScheduledBodyClassName = contactCenterClassName('transfers-scheduled-view__body', 'grid-view__body')
        return (
            <div className={transfersScheduledClassName}>
                <div className="container-fluid">
                    <div className="row transfers-scheduled-view--header-identifier">
                        <OKCover size="medium" section="transfers" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                tutorial={tutorial}
                                finalTitle={getFinalTitle('transfersLanding-scheduledTranfers')}>
                                {moreOptionsButton}
                                {optionsButton}
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className={transfersScheduledBodyClassName}>
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12">
                                <OKSectionBox>
                                    {content}
                                </OKSectionBox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

TransfersScheduledView.propTypes = {
    clearFilters: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immScheduledTransfers: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    requestScheduledTransfers: PropTypes.func.isRequired,
    requestScheduledTransfersNextPage: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    setFilters: PropTypes.func.isRequired,
};

module.exports.constructor = TransfersScheduledView;
module.exports.TransfersScheduledView = connect(
    state => ({
        immAccounts: state.accounts,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immScheduledTransfers: state.scheduledTransfers,
        immScreen: state.screen,
    }),
    {
        requestScheduledTransfers: scheduledTransfersActions.requestScheduledTransfers,
        setFilters: scheduledTransfersActions.setScheduledTransfersFilters,
        resetFilter: scheduledTransfersActions.resetScheduledTransfersFilter,
        clearFilters: scheduledTransfersActions.clearScheduledTransfersFilters,
        requestScheduledTransfersNextPage: scheduledTransfersActions.requestScheduledTransfersNextPage
    }
)(TransfersScheduledView);
